import { render, staticRenderFns } from "./ClientNavigation.vue?vue&type=template&id=1806e55e"
import script from "./ClientNavigation.vue?vue&type=script&lang=js"
export * from "./ClientNavigation.vue?vue&type=script&lang=js"
import style0 from "./ClientNavigation.vue?vue&type=style&index=0&id=1806e55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports